// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tm-container {
  padding: 30px 40px;
  color: var(--text-primary);
  max-width: 1200px;
  margin: 0 auto;
}

.tm-header {
  margin-bottom: 30px;
}

.tm-header h1 {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 8px;
}

.tm-header p {
  color: var(--text-secondary);
  font-size: 0.9rem;
}

.tm-card {
  background: var(--bg-card);
  backdrop-filter: blur(25px);
  -webkit-backdrop-filter: blur(25px);
  border: 1px solid var(--border-subtle);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 30px;
  box-shadow: var(--shadow-md);
  overflow-x: auto;
}

.tm-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

.tm-table th {
  padding: 12px 16px;
  color: var(--text-muted);
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 1px solid var(--border-subtle);
}

.tm-table td {
  padding: 16px;
  border-bottom: 1px solid var(--border-subtle);
  vertical-align: middle;
  font-size: 0.9rem;
}

.tm-table tr:last-child td {
  border-bottom: none;
}

.tm-name {
  font-weight: 500;
  color: var(--text-primary);
}

.tm-email {
  color: var(--text-secondary);
}

.tm-role-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: capitalize;
}

.role-admin {
  background: rgba(139, 92, 246, 0.15);
  color: #8b5cf6;
}

.role-manager {
  background: rgba(16, 185, 129, 0.15);
  color: var(--accent-emerald);
}

.role-viewer {
  background: rgba(107, 114, 128, 0.15);
  color: var(--text-secondary);
}

.tm-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  font-size: 0.85rem;
  color: var(--text-secondary);
}

.tm-status {
  font-size: 0.85rem;
  font-weight: 500;
}

.tm-status.active {
  color: #10b981;
}

.tm-status.disabled {
  color: #ef4444;
}

.tm-action-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 0.85rem;
  font-weight: 500;
  padding: 6px 12px;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.tm-action-btn.disable {
  color: #ef4444;
}
.tm-action-btn.disable:hover {
  background: rgba(239, 68, 68, 0.1);
}

.tm-action-btn.enable {
  color: #10b981;
}
.tm-action-btn.enable:hover {
  background: rgba(16, 185, 129, 0.1);
}

/* SSO Card */
.sso-card {
  padding: 30px;
}

.sso-header {
  margin-bottom: 24px;
}

.sso-header h3 {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 6px;
  color: var(--text-primary);
}

.sso-header p {
  color: var(--text-secondary);
  font-size: 0.9rem;
}

.sso-default-admin {
  background: rgba(139, 92, 246, 0.05);
  border: 1px solid rgba(139, 92, 246, 0.2);
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 24px;
}

.sso-default-admin h4 {
  font-size: 0.9rem;
  font-weight: 600;
  color: #8b5cf6;
  margin-bottom: 4px;
}

.sso-group-id {
  display: block;
  font-family: monospace;
  font-size: 0.85rem;
  color: var(--text-secondary);
  margin-bottom: 4px;
}

.sso-default-admin p {
  font-size: 0.85rem;
  color: var(--text-secondary);
  margin: 0;
}

.sso-mappings-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
}

.sso-mapping-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.sso-input-wrapper {
  flex: 1 1;
}

.sso-input-wrapper input {
  width: 100%;
  background: var(--bg-glass);
  border: 1px solid var(--border-subtle);
  color: var(--text-primary);
  padding: 10px 14px;
  border-radius: 6px;
  font-size: 0.9rem;
  font-family: monospace;
}

.sso-input-wrapper input[readOnly] {
  opacity: 0.8;
  cursor: default;
}

.sso-select-wrapper select {
  width: 160px;
  background: var(--bg-glass);
  border: 1px solid var(--border-subtle);
  color: var(--text-primary);
  padding: 10px 14px;
  border-radius: 6px;
  font-size: 0.9rem;
  cursor: pointer;
  appearance: none;
}

.sso-select-wrapper select:focus,
.sso-input-wrapper input:focus {
  outline: none;
  border-color: var(--border-active);
}

.sso-delete-btn {
  background: transparent;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.sso-delete-btn:hover {
  color: #ef4444;
  background: rgba(239, 68, 68, 0.1);
}

.sso-add-btn {
  background: transparent;
  border: 1px solid var(--border-subtle);
  color: var(--text-primary);
  padding: 10px 16px;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.sso-add-btn:hover:not(:disabled) {
  background: var(--bg-glass-hover);
}

.sso-add-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.sso-footer-help {
  border-top: 1px solid var(--border-subtle);
  padding-top: 20px;
}

.sso-footer-help h5 {
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 8px;
  color: var(--text-primary);
}

.sso-footer-help ul {
  margin: 0;
  padding-left: 20px;
  color: var(--text-secondary);
  font-size: 0.85rem;
}

.sso-footer-help li {
  margin-bottom: 4px;
}

.tm-empty {
  text-align: center;
  color: var(--text-muted);
  padding: 40px !important;
}

.tm-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  color: var(--text-secondary);
  font-size: 1.1rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/TeamMembers.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;EACnC,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,6CAA6C;EAC7C,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;AACA;EACE,mCAAmC;AACrC;;AAEA,aAAa;AACb;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,sCAAsC;EACtC,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,sCAAsC;EACtC,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,sCAAsC;EACtC,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,4BAA4B;EAC5B,iBAAiB;AACnB","sourcesContent":[".tm-container {\n  padding: 30px 40px;\n  color: var(--text-primary);\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.tm-header {\n  margin-bottom: 30px;\n}\n\n.tm-header h1 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.tm-header p {\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n}\n\n.tm-card {\n  background: var(--bg-card);\n  backdrop-filter: blur(25px);\n  -webkit-backdrop-filter: blur(25px);\n  border: 1px solid var(--border-subtle);\n  border-radius: 12px;\n  padding: 20px;\n  margin-bottom: 30px;\n  box-shadow: var(--shadow-md);\n  overflow-x: auto;\n}\n\n.tm-table {\n  width: 100%;\n  border-collapse: collapse;\n  text-align: left;\n}\n\n.tm-table th {\n  padding: 12px 16px;\n  color: var(--text-muted);\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  border-bottom: 1px solid var(--border-subtle);\n}\n\n.tm-table td {\n  padding: 16px;\n  border-bottom: 1px solid var(--border-subtle);\n  vertical-align: middle;\n  font-size: 0.9rem;\n}\n\n.tm-table tr:last-child td {\n  border-bottom: none;\n}\n\n.tm-name {\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n.tm-email {\n  color: var(--text-secondary);\n}\n\n.tm-role-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 10px;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: capitalize;\n}\n\n.role-admin {\n  background: rgba(139, 92, 246, 0.15);\n  color: #8b5cf6;\n}\n\n.role-manager {\n  background: rgba(16, 185, 129, 0.15);\n  color: var(--accent-emerald);\n}\n\n.role-viewer {\n  background: rgba(107, 114, 128, 0.15);\n  color: var(--text-secondary);\n}\n\n.tm-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  user-select: none;\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n}\n\n.tm-status {\n  font-size: 0.85rem;\n  font-weight: 500;\n}\n\n.tm-status.active {\n  color: #10b981;\n}\n\n.tm-status.disabled {\n  color: #ef4444;\n}\n\n.tm-action-btn {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  font-size: 0.85rem;\n  font-weight: 500;\n  padding: 6px 12px;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.tm-action-btn.disable {\n  color: #ef4444;\n}\n.tm-action-btn.disable:hover {\n  background: rgba(239, 68, 68, 0.1);\n}\n\n.tm-action-btn.enable {\n  color: #10b981;\n}\n.tm-action-btn.enable:hover {\n  background: rgba(16, 185, 129, 0.1);\n}\n\n/* SSO Card */\n.sso-card {\n  padding: 30px;\n}\n\n.sso-header {\n  margin-bottom: 24px;\n}\n\n.sso-header h3 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin-bottom: 6px;\n  color: var(--text-primary);\n}\n\n.sso-header p {\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n}\n\n.sso-default-admin {\n  background: rgba(139, 92, 246, 0.05);\n  border: 1px solid rgba(139, 92, 246, 0.2);\n  border-radius: 8px;\n  padding: 16px 20px;\n  margin-bottom: 24px;\n}\n\n.sso-default-admin h4 {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #8b5cf6;\n  margin-bottom: 4px;\n}\n\n.sso-group-id {\n  display: block;\n  font-family: monospace;\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n  margin-bottom: 4px;\n}\n\n.sso-default-admin p {\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n  margin: 0;\n}\n\n.sso-mappings-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.sso-mapping-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.sso-input-wrapper {\n  flex: 1;\n}\n\n.sso-input-wrapper input {\n  width: 100%;\n  background: var(--bg-glass);\n  border: 1px solid var(--border-subtle);\n  color: var(--text-primary);\n  padding: 10px 14px;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  font-family: monospace;\n}\n\n.sso-input-wrapper input[readOnly] {\n  opacity: 0.8;\n  cursor: default;\n}\n\n.sso-select-wrapper select {\n  width: 160px;\n  background: var(--bg-glass);\n  border: 1px solid var(--border-subtle);\n  color: var(--text-primary);\n  padding: 10px 14px;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  cursor: pointer;\n  appearance: none;\n}\n\n.sso-select-wrapper select:focus,\n.sso-input-wrapper input:focus {\n  outline: none;\n  border-color: var(--border-active);\n}\n\n.sso-delete-btn {\n  background: transparent;\n  border: none;\n  color: var(--text-muted);\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.sso-delete-btn:hover {\n  color: #ef4444;\n  background: rgba(239, 68, 68, 0.1);\n}\n\n.sso-add-btn {\n  background: transparent;\n  border: 1px solid var(--border-subtle);\n  color: var(--text-primary);\n  padding: 10px 16px;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.sso-add-btn:hover:not(:disabled) {\n  background: var(--bg-glass-hover);\n}\n\n.sso-add-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.sso-footer-help {\n  border-top: 1px solid var(--border-subtle);\n  padding-top: 20px;\n}\n\n.sso-footer-help h5 {\n  font-size: 0.9rem;\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: var(--text-primary);\n}\n\n.sso-footer-help ul {\n  margin: 0;\n  padding-left: 20px;\n  color: var(--text-secondary);\n  font-size: 0.85rem;\n}\n\n.sso-footer-help li {\n  margin-bottom: 4px;\n}\n\n.tm-empty {\n  text-align: center;\n  color: var(--text-muted);\n  padding: 40px !important;\n}\n\n.tm-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n  color: var(--text-secondary);\n  font-size: 1.1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
